module.exports = __webpack_public_path__ + "img/ram.e709764e.png";